import { FC } from 'react';
import { Button, Text } from '@livechat/design-system-react-components';

import { VerificationCodeField } from 'components/verification-code-field/VerificationCodeField';
import { useSendVerificationCode } from 'hooks/use-send-verification-code';
import { getQueryClient } from 'services/ReactQueryClient';

import { OrganizationDetails } from '../organization-details/OrganizationDetails';

import * as styles from './styles';

type Props = {
  email: string;
};

export const VerificationTile: FC<Props> = ({ email }) => {
  const {
    sendVerificationCode,
    isProcessing,
    data: isVerificationSend,
  } = useSendVerificationCode(email);

  const handleSendVerificationCode = (): void => {
    sendVerificationCode(true);
  };

  const handleAppRefresh = async (): Promise<void> => {
    const queryClient = getQueryClient();
    queryClient.invalidateQueries(['get-me']);
  };

  return (
    <OrganizationDetails hideOrganizationName>
      <div css={styles.verifyEmail}>
        <Text bold>Confirm your email address to see more organizations</Text>
        {isVerificationSend && (
          <>
            <Text>Enter the code from the confirmation email.</Text>
            <VerificationCodeField
              email={email}
              onVerificationWithoutProductCompleted={handleAppRefresh}
              isAccountWhitelisted
            />
          </>
        )}
        {!isVerificationSend && (
          <div>
            <Button
              kind="secondary"
              size="medium"
              loading={isProcessing}
              onClick={handleSendVerificationCode}
            >
              Send confirmation email
            </Button>
          </div>
        )}
      </div>
    </OrganizationDetails>
  );
};
